<template>
  <div class="checkin-step4">
    <div class="step4-module">
      <h4>到达城市天气预报</h4>
      <div class="weather-area clearfix">
        <div class="weather-area-overflow">
          <div class="weather-item" v-for="day in weather" :key="day.index">
            <p class="weather-time" v-if="day.index == 0">24小时</p>
            <p class="weather-time" v-if="day.index == 1">48小时</p>
            <p class="weather-time" v-if="day.index == 2">72小时</p>
            <p class="weather-icon">
              <l8-icon class="l8-icon" :type="day.icon" />
            </p>
            <p class="weather-text">{{day.description}}</p>
            <p class="weather-number">{{day.lowTemperature}}~11℃{{day.highTemperature}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="step4-module" v-if="stepData.passengerInfoList?.length > 0">
      <h4>值机信息</h4>
      <div class="flight-info-components" >
        <template v-for="item in stepData.passengerInfoList" >
          <flightInfo :key="item.ticketID" :passengerData="item" :flightStatus="'checked'"></flightInfo>
        </template>
      </div>
    </div>
    <div class="step4-module print-rule" v-if="cmsData.checkinWays && cmsData.checkinWays.content" v-html="cmsData.checkinWays.content"></div>
    <div class="step-operation">
      <a-button type="primary" size="large" class="step4-btn" @click="handleSave" v-if="!['UQ', '8L'].includes(airline) && (airline === 'Y8' && !banCities)">保存登机牌</a-button>
      <a-button type="primary" size="large" class="step4-btn" @click="gohome">完成办理</a-button>
    </div>
  </div>
</template>
<script>
import { weather } from '@/apis/checkin'
import axios from 'axios'
import moment from 'moment'
import flightInfo from './flightInfo'
import '@/components/l8-icon'
import getAppInfo from '@/utils/from'
import { getBanCities } from '../data'

const weatherMap = {
  '晴': 'icon-riqing',
  '多云': 'icon-rijianduoyun',
  '阴': 'icon-yin',
  '阵雨': 'icon-zhenyusvg',
  '雷阵雨': 'icon-leizhenyu',
  '雨': 'icon-xiaoyu',
  '小雨': 'icon-xiaoyu',
  '中雨': 'icon-zhongyu',
  '大雨': 'icon-dayu',
  '暴雨': 'icon-baoyu',
  '雨夹雪': 'icon-yujiaxue',
  '雪': 'icon-xiaoxue',
  '小雪': 'icon-xiaoxue',
  '中雪': 'icon-zhongxue',
  '大雪': 'icon-daxue',
  '暴雪': 'icon-baoxue',
  '雾': 'icon-wu',
  '浓雾': 'icon-nongwu',
  '沙尘暴': 'icon-shachenbao',
  '强沙尘暴': 'icon-qiangshachenbao',
  '霾': 'icon-mai',
  '中度霾': 'icon-zhongdumai',
  '重度霾': 'icon-zhongdumai1',
  '严重霾': 'icon-yanzhongmai',
  '浮尘': 'icon-fuchen'
}
export default {
  props: {
    stepData: Object,
    cmsData: Object,
    pageData: Object
  },
  data () {
    return {
      weatherMap,
      weather: [],
      appInfo: getAppInfo(),
      airline: window.__MICRO_ROOT__?.airline
    }
  },
  created () {
    this.getWeather()
  },
  computed: {
    banCities () {
      return getBanCities(this.pageData?.depCode, this.pageData?.cabin)
    }
  },
  methods: {
    async getWeather () {
      const data = {
        city: 'CGD'
      }
      try {
        const result = await weather(data)
        result.weather.forEach(item => {
          let des = item.description.split(' ')[0]
          item.icon = this.weatherMap[des]
          this.weather.push(item)
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async handleSave () {
      const { stepData } = this
      for (let index = 0; index < stepData.passengerInfoList?.length; index++) {
        const item = stepData.passengerInfoList[index] ?? {}
        const params = {
          dataFlow: item.boardStreams?.[0],
          depTime: moment(item.flightDate).valueOf(),
          tourIndex: item.tourIndex
        }
        try {
          await this.outputPDF(params)
        } catch (e) {
          this.$message.error(e.message)
        }
      }
    },
    outputPDF (data) {
      const airline = window.__MICRO_ROOT__?.airline
      axios({
        method: 'post',
        url: '/api/checkin/pdfBoardingV2',
        headers: {
          airline,
          channel: 'C' + airline
        },
        data,
        responseType: 'blob'
      }).then(({ status, data }) => {
        if (status === 200) {
          if (!window.Blob) {
            this.$message.error('该浏览器不支持数据流下载，请更换浏览器')
            return
          }
          const blob = new Blob([data])
          const fileName = '登机牌.pdf'
          if ('download' in document.createElement('a')) {
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          } else {
            navigator.msSaveBlob(blob, fileName)
          }
        } else {
          this.$message.error('网络异常，请稍后再试！')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    gohome () {
      window.__MICRO_ROOT__?.router.push({ pathname: '/' })
    }
  },
  components: {
    flightInfo
  }
}
</script>

<style lang="less" scoped>
.checkin-step4 {
  h4 {
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
    span {
      font-size: 12px;
      font-weight: normal;
    }
  }
  .step4-module {
    margin-bottom: 50px;
  }
  .weather-area {
    padding-top: 10px;
  }
  .weather-item {
    float: left;
    width: 33.33%;
    text-align: center;
    font-size: 12px;
    .weather-time {
      line-height: 24px;
    }
    .weather-icon {
      margin-bottom: 5px;
    }
    .l8-icon {
      font-size: 55px;
    }
    .weather-number {
      margin-top: 10px;
    }
  }
  .param {
    width: 92%;
    margin-bottom: 20px;
    font-size: 14px;
    color: #808080;
    line-height: 22px;
    span {
      display: inline-block;
      vertical-align: top;
    }
    span.span-long {
      width: 85%;
    }
  }
  .step-operation {
    padding-top: 10px;
    padding-bottom: 30px;
    text-align: center;
    .step4-btn.ant-btn {
      margin: 0 20px;
      padding: 0px 35px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .checkin-step4 {
    h4 {
      margin-left: 10px;
      span {
        display: block;
      }
    }
    .weather-area {
      overflow-x: scroll;
      .weather-area-overflow {
        width: 130%;
      }
    }
    .flight-info-components {
      width: 96%;
      border: 1px solid #bfbfbf;
      margin: 0 auto;
      overflow-x: scroll;
    }
    .step4-module {
      margin-bottom: 30px;
    }
    .print-rule {
      h4 {
        margin-bottom: 10px;
      }
      .param {
        width: 96%;
        margin: 0 auto;
        margin-bottom: 10px;
        .span-title {
          font-weight: bold;
        }
        .span-long {
          display: block;
          width: 96%;
          margin: 0 auto;
        }
      }
    }
    .step-operation {
      padding-bottom: 10px;
    }
    .step-operation .step4-btn.ant-btn {
      display: block;
      width: 96%;
      margin: 0 auto;
      margin-bottom: 15px;
    }
  }
}
</style>
